var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7983 0C6.16201 0 0.782227 5.37258 0.782227 12C0.782227 18.6274 6.16201 24 12.7983 24C19.4346 24 24.8144 18.6274 24.8144 12C24.8144 5.37258 19.4346 0 12.7983 0ZM6.55076 9.93892H9.27387V18.1098H6.55076V9.93892ZM9.45322 7.41135C9.43555 6.6102 8.86187 6 7.93032 6C6.99876 6 6.38974 6.6102 6.38974 7.41135C6.38974 8.1959 6.98076 8.82367 7.89497 8.82367H7.91237C8.86187 8.82367 9.45322 8.1959 9.45322 7.41135ZM15.9591 9.74706C17.751 9.74706 19.0944 10.9151 19.0944 13.4249L19.0943 18.1098H16.3713V13.7384C16.3713 12.6404 15.9773 11.8911 14.9915 11.8911C14.2392 11.8911 13.7911 12.3962 13.5943 12.8841C13.5223 13.0589 13.5046 13.3025 13.5046 13.5467V18.11H10.7812C10.7812 18.11 10.8171 10.7059 10.7812 9.93914H13.5046V11.0965C13.866 10.5401 14.5133 9.74706 15.9591 9.74706Z",
    fill: "#3784F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e961ee48becf9634ae18506fc0f2d5ad.svg";
export { ForwardRef as ReactComponent };